var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOutlinedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 18.002,
    height: 18,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2099",
    "data-name": "Groupe 2099",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2098",
    "data-name": "Groupe 2098",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_772",
    "data-name": "Trac\\xE9 772",
    d: "M11.06,6.02l.92.92L2.92,16H2v-.92l9.06-9.06M14.66,0a1,1,0,0,0-.7.29L12.13,2.12l3.75,3.75,1.83-1.83a1,1,0,0,0,0-1.41L15.37.29A.982.982,0,0,0,14.66,0m-3.6,3.19L0,14.25V18H3.75L14.81,6.94,11.06,3.19",
    fill: "#1454FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlinedBlue);
export default __webpack_public_path__ + "static/media/EditOutlinedBlue.c28725a0e8d05893f2c39c18430661d6.svg";
export { ForwardRef as ReactComponent };